<template>
	<ThemeConfiguration css-layer="theme-config" />
	<NuxtLayout name="site-structure">
		<SiteHeader site-name="MBA" />

		<main id="main" class="bg-site-background min-h-[500px]">
			<article
				class="w-full max-w-layout-max px-layout-margin py-25 >=568:py-35 mx-auto text-white"
			>
				<header
					v-if="error"
					class="text-white w-full px-layout-margin pt-[35px] mb-[50px]"
				>
					<h1
						v-if="error.statusCode || error.message"
						class="text-45 font-light mb-[10px]"
					>
						{{ error.statusCode }}, {{ error.message }}
					</h1>

					<p
						v-if="error.statusMessage"
						class="whitespace-pre-line text-22"
						v-html="error.statusMessage"
					></p>
				</header>
			</article>
		</main>

		<SiteFooter class="mt-auto" />
	</NuxtLayout>
</template>

<script setup>
import '~/assets/css/index.css';
import { useMainStore } from '~/store/main';
const route = useRoute();

// Fetch site data
if (process.server) {
	const { $umbracoClient } = useNuxtApp();
	let data = await $umbracoClient.fetchData({
		params: {
			...route.query,
			cache: false,
			parts: ['site'],
		},
		route: route.fullPath,
	});

	if (data.site) {
		const main = useMainStore();
		main.setSiteData(data.site);
	}
}

// Handle login
const mainStore = useMainStore();

const updateLogin = async () => {
	// Get state and set in store
	await $fetch('/api/login/isloggedin', {
		method: 'GET',
	})
		.then((response) => {
			mainStore.setLoggedIn(!(response?.isLoggedOut ?? true), response);
		})
		.catch((error) => {
			console.log(error);
			mainStore.setLoggedIn(false);
		});
};

await updateLogin();
onMounted(updateLogin);
onUpdated(updateLogin);

const props = defineProps({
	error: Object,
});
</script>
